module.exports = __webpack_public_path__ + "img/banner-3-1@1x.ddba87a3.jpg";